import { createAction, props } from '@ngrx/store';
import { FareReviewItem, FareReviewTriggerType } from '@uzurv/clara';
import { HttpException } from '@uzurv/core';
import { FareReviewQueueState } from './fare-review-queue.reducer';

export const GetFareReviewItems = createAction('[Fare Review Queue] Get Fare Review Items');

export const GetFareReviewItemsSuccess = createAction(
  '[Fare Review Queue] Get Fare Review Items Success',
  props<{ fareReviewItems: Array<{ fareReviewItem: FareReviewItem; disabled: boolean }> }>()
);

export const GetFareReviewItemsFailure = createAction(
  '[Fare Review Queue] Get Fare Review Items Failure',
  props<{ error: HttpException }>()
);

export const GetFareReviewTriggerType = createAction('[Fare Review Queue] Get Fare Review Trigger Type');

export const GetFareReviewTriggerTypeSuccess = createAction(
  '[Fare Review Queue] Get Fare Review Trigger Type Success',
  props<{ triggerTypes: Array<FareReviewTriggerType> }>()
);

export const GetFareReviewTriggerTypeFailure = createAction(
  '[Fare Review Queue] Get Fare Review Trigger Type Failure',
  props<{ error: HttpException }>()
);

export const SelectFareReviewTrigger = createAction(
  '[Fare Review Queue] Select Fare Review Trigger',
  props<{ fareReviewTriggerName: string }>()
);

export const SelectFareReviewTriggerSuccess = createAction(
  '[Fare Review Queue] Select Fare Review Trigger Success',
  props<{ fareReviewItems: Array<{ fareReviewItem: FareReviewItem; disabled: boolean }> }>()
);

export const SelectFareReviewTriggerFailure = createAction(
  '[Fare Review Queue] Select Fare Review Trigger Failure',
  props<{ error: HttpException }>()
);

export const PaginateFareReviewItems = createAction(
  '[Fare Review Queue] Paginate Fare Review Items',
  props<{ pageNumber: number; pageSize: number }>()
);

export const PaginateFareReviewItemsSuccess = createAction(
  '[Fare Review Queue] Paginate Fare Review Items Success',
  props<{ fareReviewItems: Array<{ fareReviewItem: FareReviewItem; disabled: boolean }> }>()
);

export const PaginateFareReviewItemsFailure = createAction(
  '[Fare Review Queue] Paginate Fare Review Items Failure',
  props<{ error: HttpException }>()
);

export const RestoreState = createAction('[Fare Review Queue] Restore State', props<{ state: FareReviewQueueState }>());
